const scripts = new Map();
function loadScript(url) {
    const existing = scripts.get(url);
    if (existing)
        return existing;
    const promise = new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = url;
        el.async = true;
        const timer = setTimeout(() => { el.remove(); scripts.delete(url); reject(new Error('Площадка не отвечает')); }, 15000);
        el.onload = () => { clearTimeout(timer); resolve(); };
        el.onerror = () => { clearTimeout(timer); el.remove(); scripts.delete(url); reject(new Error('Не удалось подключиться к площадке')); };
        document.head.appendChild(el);
    });
    scripts.set(url, promise);
    return promise;
}
export class NativeBridge {
    match;
    emit;
    dead = false;
    sdk = null;
    frame = null;
    timer = null;
    deadline = null;
    unlisten = null;
    ready = false;
    polling = false;
    constructor(match, emit) {
        this.match = match;
        this.emit = emit;
    }
    event(e) { if (this.dead)
        return; if (e.kind === 'ready') {
        this.ready = true;
        if (this.deadline)
            clearTimeout(this.deadline);
    } this.emit(e); }
    iframe(container, onLoad) {
        const frame = document.createElement('iframe');
        frame.src = this.match.embedUrl;
        frame.title = `Плеер ${this.match.label}`;
        frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        if (onLoad) {
            frame.addEventListener('load', onLoad);
            this.unlisten = () => frame.removeEventListener('load', onLoad);
        }
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.style.cssText = 'width:100%;height:100%;border:0';
        this.frame = frame;
        container.appendChild(frame);
        return frame;
    }
    async mount(container) {
        this.deadline = setTimeout(() => { if (!this.ready)
            this.event({ kind: 'error', error: 'Площадка не ответила. Проверьте доступ к видео или повторите подключение.' }); }, 20000);
        try {
            if (this.match.kind === 'rutube') {
                this.rutube(container);
                return;
            }
            if (this.match.kind === 'youtube') {
                const win = window;
                if (!win.YT?.Player) {
                    await loadScript('https://www.youtube.com/iframe_api');
                    for (let i = 0; i < 100 && !win.YT?.Player && !this.dead; i++)
                        await new Promise(r => setTimeout(r, 100));
                }
                if (this.dead)
                    return;
                if (!win.YT?.Player)
                    throw new Error('YouTube API недоступен');
                const host = document.createElement('div');
                container.appendChild(host);
                const state = (n) => n === 1 ? 'playing' : n === 2 ? 'paused' : n === 3 ? 'buffering' : n === 0 ? 'ended' : 'unknown';
                this.sdk = new win.YT.Player(host, { videoId: this.match.videoId, playerVars: { playsinline: 1, controls: 1, origin: location.origin, rel: 0 }, events: {
                        onReady: (e) => { if (this.dead)
                            return; this.sdk = e.target; this.event({ kind: 'ready' }); this.poll(() => ({ kind: 'time', positionMs: this.sdk?.getCurrentTime() * 1000, durationMs: this.sdk?.getDuration() * 1000 })); },
                        onStateChange: (e) => this.event({ kind: 'state', state: state(e.data), positionMs: this.sdk?.getCurrentTime() * 1000 }),
                        onPlaybackRateChange: (e) => this.event({ kind: 'rate', rate: e.data }),
                        onAutoplayBlocked: () => this.event({ kind: 'blocked' }),
                        onError: (e) => this.event({ kind: 'error', error: [101, 150].includes(e.data) ? 'Автор запретил встраивание этого видео. Выберите другой ролик.' : `YouTube не открыл видео (код ${e.data}).` })
                    } });
                return;
            }
            if (this.match.kind === 'vk') {
                const win = window;
                if (!win.VK?.VideoPlayer)
                    await loadScript('https://vk.com/js/api/videoplayer.js');
                if (this.dead)
                    return;
                // VK's SDK sends init only once. Sending it into about:blank loses the handshake.
                const frame = this.iframe(container, () => {
                    if (this.dead)
                        return;
                    this.disposeSdk();
                    try {
                        this.sdk = win.VK.VideoPlayer(frame);
                        const sample = (kind, state) => (e = {}) => this.event({ kind, state, positionMs: Number(e.time ?? this.sdk?.getCurrentTime()) * 1000, durationMs: Number(e.duration ?? this.sdk?.getDuration()) * 1000 });
                        this.sdk.on('inited', sample('ready'));
                        this.sdk.on('timeupdate', sample('time'));
                        this.sdk.on('started', sample('state', 'playing'));
                        this.sdk.on('resumed', sample('state', 'playing'));
                        this.sdk.on('paused', sample('state', 'paused'));
                        this.sdk.on('ended', sample('state', 'ended'));
                        this.sdk.on('seeked', sample('seek'));
                        this.sdk.on('adStarted', () => this.event({ kind: 'ad', ad: true }));
                        this.sdk.on('adCompleted', () => this.event({ kind: 'ad', ad: false }));
                        this.sdk.on('autoplaySoundProhibited', () => this.event({ kind: 'blocked' }));
                        this.sdk.on('error', () => this.event({ kind: 'error', error: 'VK Видео не открыл ролик. Проверьте ссылку и разрешение на встраивание.' }));
                    }
                    catch {
                        this.event({ kind: 'error', error: 'Не удалось подключить API VK Видео. Повторите подключение.' });
                    }
                });
                return;
            }
            if (this.match.kind === 'vimeo') {
                const win = window;
                if (!win.Vimeo?.Player)
                    await loadScript('https://player.vimeo.com/api/player.js');
                if (this.dead)
                    return;
                const sdk = new win.Vimeo.Player(this.iframe(container));
                this.sdk = sdk;
                const sample = (kind, state) => (e = {}) => this.event({ kind, state, positionMs: typeof e.seconds === 'number' ? e.seconds * 1000 : undefined, durationMs: typeof e.duration === 'number' ? e.duration * 1000 : undefined });
                this.sdk.on('playing', sample('state', 'playing'));
                this.sdk.on('pause', sample('state', 'paused'));
                this.sdk.on('ended', sample('state', 'ended'));
                this.sdk.on('timeupdate', sample('time'));
                this.sdk.on('seeked', sample('seek'));
                this.sdk.on('bufferstart', sample('state', 'buffering'));
                sdk.on('bufferend', () => { void sdk.getPaused().then((paused) => this.event({ kind: 'state', state: paused ? 'paused' : 'playing' })).catch(() => { }); });
                this.sdk.on('playbackratechange', (e) => this.event({ kind: 'rate', rate: e.playbackRate }));
                this.sdk.on('error', () => this.event({ kind: 'error', error: 'Vimeo не открыл видео. Проверьте доступ и разрешение на встраивание.' }));
                await sdk.ready();
                if (this.dead)
                    return;
                this.event({ kind: 'ready' });
                // Unsupported autopause preferences must not disable time observations.
                void sdk.setAutopause(false).catch(() => { });
                this.poll(async () => ({ kind: 'time', positionMs: (await sdk.getCurrentTime()) * 1000, durationMs: (await sdk.getDuration()) * 1000 }));
                return;
            }
            throw new Error('Эта площадка не поддерживает подключённый API синхронизации.');
        }
        catch (e) {
            this.event({ kind: 'error', error: e instanceof Error ? e.message : 'Не удалось открыть плеер' });
        }
    }
    poll(read) {
        if (this.dead)
            return;
        if (this.timer)
            clearInterval(this.timer);
        this.timer = setInterval(() => { if (this.dead || this.polling)
            return; this.polling = true; void Promise.resolve().then(read).then(e => this.event(e)).catch(() => { }).finally(() => { this.polling = false; }); }, 500);
    }
    rutube(container) {
        const frame = this.iframe(container);
        const origin = new URL(this.match.embedUrl).origin;
        const handler = (event) => {
            if (event.source !== frame.contentWindow || event.origin !== origin || this.dead)
                return;
            let message;
            try {
                message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            }
            catch {
                return;
            }
            if (!message || typeof message.type !== 'string')
                return;
            const d = message.data ?? {};
            switch (message.type) {
                case 'player:ready':
                    this.event({ kind: 'ready' });
                    break;
                case 'player:currentTime':
                    this.event({ kind: 'time', positionMs: typeof d.time === 'number' ? d.time * 1000 : undefined, durationMs: typeof d.duration === 'number' ? d.duration * 1000 : undefined });
                    break;
                case 'player:durationChange':
                    this.event({ kind: 'time', durationMs: Number(d.duration) * 1000 });
                    break;
                case 'player:changeState': {
                    const state = d.state === 'playing' ? 'playing' : d.state === 'paused' || d.state === 'pause' ? 'paused' : d.state === 'buffering' ? 'buffering' : d.state === 'stopped' || d.state === 'completed' ? 'ended' : 'unknown';
                    // The same channel also carries lock-screen/UI states. They do not
                    // invalidate the last known playback state.
                    if (state !== 'unknown')
                        this.event({ kind: 'state', state });
                    break;
                }
                case 'player:adStart':
                    this.event({ kind: 'ad', ad: true });
                    break;
                case 'player:adEnd':
                    this.event({ kind: 'ad', ad: false });
                    break;
                case 'player:rollState':
                    if (d.state === 'play' || d.state === 'complete')
                        this.event({ kind: 'ad', ad: d.state === 'play' });
                    break;
                case 'player:error':
                    this.event({ kind: 'error', error: 'Rutube не открыл видео. Проверьте доступ и ссылку.' });
                    break;
            }
        };
        window.addEventListener('message', handler);
        this.unlisten = () => window.removeEventListener('message', handler);
    }
    command(action, value = 0) {
        if (this.dead)
            return;
        try {
            let result;
            if (this.match.kind === 'rutube') {
                if (action === 'rate')
                    return;
                this.frame?.contentWindow?.postMessage(JSON.stringify({ type: action === 'seek' ? 'player:setCurrentTime' : `player:${action}`, data: action === 'seek' ? { time: value / 1000 } : {} }), new URL(this.match.embedUrl).origin);
                return;
            }
            if (!this.sdk)
                return;
            if (this.match.kind === 'youtube')
                result = action === 'seek' ? this.sdk.seekTo(value / 1000, true) : action === 'rate' ? this.sdk.setPlaybackRate(value) : action === 'play' ? this.sdk.playVideo() : this.sdk.pauseVideo();
            else if (this.match.kind === 'vk')
                result = action === 'seek' ? this.sdk.seek(value / 1000) : action === 'rate' ? undefined : this.sdk[action]();
            else
                result = action === 'seek' ? this.sdk.setCurrentTime(value / 1000) : action === 'rate' ? this.sdk.setPlaybackRate(value) : this.sdk[action]();
            void Promise.resolve(result).catch(e => { if (action === 'play' && (e?.name === 'NotAllowedError' || e?.name === 'PlayInterrupted'))
                this.event({ kind: 'blocked' });
            else
                this.event({ kind: 'error', error: 'Площадка отклонила команду. Повторите подключение.' }); });
        }
        catch {
            this.event({ kind: 'error', error: 'Плеер площадки не готов к управлению.' });
        }
    }
    disposeSdk() { const sdk = this.sdk; this.sdk = null; try {
        void Promise.resolve(sdk?.destroy()).catch(() => { });
    }
    catch { } }
    destroy() { if (this.dead)
        return; this.dead = true; if (this.timer)
        clearInterval(this.timer); if (this.deadline)
        clearTimeout(this.deadline); this.unlisten?.(); this.disposeSdk(); this.frame?.remove(); }
}
//# sourceMappingURL=bridge.js.map